import React from 'react';

import { Alert } from '@mui/material';

import TENANTS from '~/consts/tenant';

import useCurrentTenant from '~/hooks/useCurrentTenant';

import TenantTitleLink from './TenantTitleLink';
import { validUserTenantForSiteTenant } from './utils';

type Props = {
  user?: Pick<App.User, 'tenant'>;
  userTenant?: string;
};

function TenancyWarningMessage({ user, userTenant: userTenantValue }: Props) {
  const { tenant } = useCurrentTenant();
  const tenantKey = userTenantValue ?? user?.tenant;

  if (!tenantKey) {
    return null;
  }

  const userTenant = TENANTS[tenantKey];
  const isTenantOfCurrentSite = validUserTenantForSiteTenant(tenant.value, tenantKey);

  if (isTenantOfCurrentSite) {
    return null;
  }

  return (
    <Alert severity="warning">
      This user is a tenant of {userTenant ? <TenantTitleLink tenant={userTenant} /> : <strong>{tenantKey}</strong>},
      but not <strong>{tenant.title}</strong>. Please view the customer's account details in the site where they are a
      tenant to unlock additional actions.
    </Alert>
  );
}

export default TenancyWarningMessage;
